export default {
  debug: false,
  api: {
    version: '',
    protocole: 'placeholder_PROTOCOL_MONEYROAD_CAPI',
    host: 'placeholder_URL_MONEYROAD_CAPI',
    port: 'placeholder_PORT_MONEYROAD_CAPI',
    applicationToken: 'null',
    address: function () {
      return this.protocole +
      '://' +
      this.host +
      (this.port !== '' ? ':' + this.port : '') +
      '/' +
      (this.version !== '' ? this.version + '/' : '')
    }
  },
  crypto: {
    secret: 'streammind'
  },
  language: 'en',
  authMode: 'placeholder_AUTH_MODE_MONEYROAD_GUI'
}
